//eslint-disable-next-line no-restricted-imports
import { useTheme } from '@material-ui/core';
import { useThemeMode } from '../../../submodules/web-shared/modules/UserPreferences/hooks/useThemeMode';
import { THEME_TYPE } from '../../consts';

const useThemeType = (defaultTheme: THEME_TYPE) => {
  const preferredTheme = useThemeMode();
  const v1Theme = useTheme();
  // Determine the theme type based on the presence of colorShades in v1Theme.
  // If colorShades exist, pages with mixed themes won't have the ability to apply dark mode
  const themeType = v1Theme.colorShades ? defaultTheme : preferredTheme;

  return themeType;
};

export default useThemeType;